// clubs.js
import Axios from "../connection";
import { applicationError } from "../../../redux/actions/error";

export const afGetClubs = async (leagueId, season) => {
  try {
    const response = await Axios.get(
      `/teams?league=${leagueId}&season=${season}`,
    );
    const data = response.data.response;

    if (!data || data.length === 0) {
      return [];
    }

    return data.map((teamData) => ({
      team_id: teamData.team.id,
      name: teamData.team.name,
      code: "",
      logo: teamData.team.logo,
      country: teamData.team.country,
      is_national: teamData.team.national,
      founded: teamData.team.founded,
      venue_name: teamData.venue?.name || "",
      venue_surface: teamData.venue?.surface || "",
      venue_address: teamData.venue?.address || "",
      venue_city: teamData.venue?.city || "",
      venue_capacity: teamData.venue?.capacity || 0,
    }));
  } catch (err) {
    applicationError({
      err,
      message: "Unable to fetch teams for the league",
      errorCode: "api-football",
    });
    throw err;
  }
};
